/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateTeamsNotificationSettingForCardRequest
 */
export interface UpdateTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTeamsNotificationSettingForCardRequest
     */
    'transactionTypes': Array<UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof UpdateTeamsNotificationSettingForCardRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTeamsNotificationSettingForCardRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTeamsNotificationSettingForCardRequest
     */
    'groupIds': Array<string>;
}

export const UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum = typeof UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum[keyof typeof UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum];


